module.exports = __webpack_public_path__ + "static/media/settings.64534265.svg";